import { z } from "zod";

export const addEmailSchema = z.object({
    idUUID: z.string().nullable().optional(),
    emailType: z.string().optional().nullable(),
    emailAddress: z.string().optional().nullable(),
    primary: z.string().optional().nullable(),
});
